import React,{useEffect, useState,forwardRef,useImperativeHandle, useLayoutEffect} from 'react'
import { Form,Input,Select, InputNumber, Button, Modal,Switch, message,Radio,Upload, Popconfirm } from 'antd';
import { ResDataType } from '@/services/ajax';
import { supplyProductTypes,saveSupplyProduct,SupplyProductType,activityListType } from "@/services/supplyProduct"
import { selectActivityList } from '@/services/activity';
const { TextArea } = Input
import { DataType } from '../column';
import usePagAndCommon from '@/hooks/usePagAndCommon';
import useChannelList from '@/hooks/useChannelList';

const ProductEdit = (props:any,ref:any) => {
    const { save } = props;
    const { getChannelList,channelName,curChannelList,handleSearch } = useChannelList();
    const { curType,setCurType,isModalOpen,setIsModalOpen } = usePagAndCommon();
    const [form] = Form.useForm();
    const [typeList,setTypelist] = useState<SupplyProductType[]>([]);
    const [activityList,setActivityList] = useState<activityListType[]>([]);
    const [curProduct,setCurProduct] = useState<DataType>();
    const getTypeList = async () => {
        const res = await supplyProductTypes() as ResDataType;
        setTypelist(res.data.list);
    }
    const getActivityList = async () => {
        const res = await selectActivityList() as ResDataType;
        setActivityList(res.data.list);
    }
    const showModal = (type:string,row?:DataType) => {
        setCurType(type);
        if(type=='edit') {
            // const {id, riskAmount, supplyChannelId, productType, productName, productPrice, parvalue, innerProductId} = row || {};
            setCurProduct(row)
            form.setFieldsValue(row)
        } else {
            form.resetFields();
        } 
        getTypeList();
        getActivityList();
        getChannelList();
        setIsModalOpen(true);
    };
    const isEdit = () => {
        return curProduct ? curProduct?.status == 0  : false; 
    }
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const defaultValue = {
                productPrice:(curProduct?.productPrice || curProduct?.productPrice == 0) ? curProduct?.productPrice : 50,
                riskAmount:(curProduct?.riskAmount|| curProduct?.riskAmount == 0) ? curProduct?.riskAmount :50,
                parvalue:(curProduct?.parvalue || curProduct?.parvalue == 0) ? curProduct?.parvalue :50,
            }
            const data = {...values,id:curType=='add'? 0 :curProduct?.id,status:curType=='add'? 0 : curProduct?.status,
                
                productType:typeList[0].value
            };
            curType=='add' ? Object.assign(data,defaultValue) : null
            const res = await saveSupplyProduct(data) as ResDataType;
            if (res.code == 0) {
                message.success(curType == 'add' ? '添加成功' : '保存成功');
                save();
                setIsModalOpen(false);
            } else {
                message.error(res.message); 
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    useImperativeHandle(ref, () => ({
        open: (type:string,row:DataType) => showModal(type,row),
    }))
    return(
        <Modal maskClosable={false}
            footer={(_, { OkBtn, CancelBtn }) => (
                <>
                    <CancelBtn />
                    <Popconfirm title="确定修改该权益活动吗？" onConfirm={()=>{handleOk()}} okText="确定" cancelText="取消">
                        <Button type="primary">确定</Button>
                    </Popconfirm>
                </>
            )}
        title={curType=='add'?'添加权益活动':'编辑权益活动'}  okText="确定" cancelText="取消" open={isModalOpen} onCancel={handleCancel}>
           <Form
                form={form}
                labelCol={{ span: 7 }}
                wrapperCol={{ span: 14 }}
                layout="horizontal"
                style={{ maxWidth: 600 }}
                >
                <Form.Item label="渠道" name='supplyChannelId' rules={[{ required: true, message: '请选择渠道' }]}>
                    <Select
                        showSearch
                        disabled={isEdit()}
                        placeholder="请选择渠道"
                        optionFilterProp="label"
                        value={channelName}
                        onSearch={handleSearch}
                        options={curChannelList}
                    />
                </Form.Item>
                <Form.Item label="权益活动名称" name='productName' rules={[{ required: true, message: '请输入权益活动名称' }]}>
                    <Input disabled={isEdit()} placeholder="请输入权益活动名称" />
                </Form.Item>
                
                {/* <Form.Item label="权益活动售价" name='productPrice' rules={[{ required: true, message: '请输入权益活动售价' }]}>
                    <InputNumber placeholder="请输入权益活动售价" style={{ width:'100%' }} min={0}/>
                </Form.Item>
                <Form.Item label="权益活动风控金额" name='riskAmount' rules={[{ required: true, message: '请输入权益活动风控金额' }]}>
                    <InputNumber placeholder="请输入权益活动风控金额" style={{ width:'100%' }} min={0}/>
                </Form.Item> */}
                
                {/* {
                    typeList.length > 1 ? <Form.Item label="权益活动类型" name='productType' rules={[{ required: true, message: '请选择权益活动类型' }]}>
                        <Select
                            disabled={isEdit()}
                            id='value'
                            placeholder="请选择权益活动类型"
                            options={
                                typeList.map((item:SupplyProductType)=> {
                                    return {key:item.value,value:item.value,label:item.description}
                                })}
                        />
                    </Form.Item> : null
                } */}
                <Form.Item label="权益包" name='innerProductId' rules={[{ required: true, message: '请选择权益包' }]}>
                        <Select
                            id='value'
                            placeholder="请选择权益包"
                            options={
                                activityList.map((item:activityListType)=> {
                                    return {key:item.activityId,value:item.activityId,label:item.activityName}
                                })
                            }
                        />
                </Form.Item>
                {/* {
                    curType!='add' &&<Form.Item label="权益活动面值" name='parvalue' rules={[{ required: true, message: '请输入权益活动面值' }]}>
                    <InputNumber placeholder="请输入权益活动面值" style={{ width:'100%' }} min={0}/>
                </Form.Item>
                } */}
            </Form>
      </Modal>
    )
}

export default forwardRef(ProductEdit)